import React, { useState } from 'react';
import { ImageIcon } from 'lucide-react';
import { CarliStars } from './CarliStars';
import { adAngles, opportunities } from '../data/demandData';
const channels = ['Meta', 'Vibe', 'TikTok', 'Klaviyo', 'Manymoons'];
export function DemandAdStudio() {
  const [inventory, setInventory] = useState(opportunities[0].id);
  const [channel, setChannel] = useState('Meta');
  const [angle, setAngle] = useState(adAngles[0].id);
  const selectedAngle = adAngles.find(item => item.id === angle) ?? adAngles[0];
  const selectedInventory = opportunities.find(item => item.id === inventory) ?? opportunities[0];
  return <section aria-labelledby="ad-studio-heading" data-id="element-505" data-mp="1nmdk41okhxex">
      <h2 id="ad-studio-heading" className="font-display text-2xl font-medium tracking-tight" data-id="element-506" data-mp="1iokg9faqlfht">Ad studio</h2>
      <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-ink/60" data-id="element-507" data-mp="c88hbc03btl6">
        Pick the inventory and the channel, and Carli drafts the creative direction. Nothing publishes without your approval.
      </p>

      <div className="mt-6 grid gap-5 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]" data-id="element-508" data-mp="3tvbppwm96k4j">
        <div className="space-y-5 rounded-2xl border border-ink/10 bg-paper p-5 shadow-sm sm:p-6" data-id="element-509" data-mp="1sknxgf4eqjb">
          <Field label="Inventory" data-id="element-510" data-mp="3jy73xxwbkqo9">
            <select value={inventory} onChange={event => setInventory(event.target.value)} className="w-full appearance-none rounded-xl border border-ink/15 bg-paper px-4 py-3 text-sm font-medium focus:border-[#BB5E40] focus:outline-none focus:ring-2 focus:ring-[#BB5E40]/20" data-id="element-511" data-mp="3jww2w5u9dx0u">
              {opportunities.map(item => <option key={item.id} value={item.id} data-id="element-512" data-mp="3188xfm8675mq">{item.brand} — {item.title}</option>)}
            </select>
          </Field>

          <Field label="Channel" data-id="element-513" data-mp="3646fbwz30k1m">
            <div className="flex flex-wrap gap-2" data-id="element-514" data-mp="2r8i25ibscmll">
              {channels.map(option => <button key={option} type="button" onClick={() => setChannel(option)} className={`rounded-full border px-3.5 py-2 text-xs font-semibold transition-colors ${channel === option ? 'border-[#BB5E40] bg-[#BB5E40] text-cream' : 'border-ink/15 text-ink/60 hover:border-[#BB5E40]/40'}`} data-id="element-515" data-mp="2w8mjfakiplcv">
                  {option}
                </button>)}
            </div>
          </Field>

          <Field label="Angle" data-id="element-516" data-mp="2w1aq4i4sq1qe">
            <div className="space-y-2" data-id="element-517" data-mp="2w09gmi3fhnas">
              {adAngles.map(option => <button key={option.id} type="button" onClick={() => setAngle(option.id)} aria-pressed={angle === option.id} className={`w-full rounded-xl border px-4 py-3 text-left transition-colors ${angle === option.id ? 'border-[#BB5E40] bg-[#BB5E40]/[0.06]' : 'border-ink/12 hover:border-[#BB5E40]/35'}`} data-id="element-518" data-mp="2r3slh3xta8o7">
                  <span className="block text-sm font-semibold" data-id="element-519" data-mp="3hdrso7h173z9">{option.name}</span>
                  <span className="mt-0.5 block text-xs text-ink/55" data-id="element-520" data-mp="3mc33olj2bkj2">{option.headline}</span>
                </button>)}
            </div>
          </Field>
        </div>

        <div className="rounded-2xl border border-[#BB5E40]/25 bg-[#BB5E40]/[0.05] p-5 sm:p-6" data-id="element-521" data-mp="3r9mhjkbulvah">
          <p className="flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-[#94452E]" data-id="element-522" data-mp="3w3z5o7o9rusk">
            <CarliStars data-id="element-523" data-mp="8x6japkhm8vm" />
            Carli's draft · {channel}
          </p>

          <div className="mt-4 rounded-xl border border-ink/10 bg-paper p-5" data-id="element-524" data-mp="8zavdusjie6z">
            <div className="flex aspect-[16/9] items-center justify-center rounded-lg border border-dashed border-ink/15 bg-cream/60 text-center" data-id="element-525" data-mp="dxccwbabi5gc">
              <span className="flex max-w-xs flex-col items-center gap-2 px-4 text-xs text-ink/55" data-id="element-526" data-mp="2fofp34zuvs30">
                <ImageIcon className="h-5 w-5 text-[#BB5E40]" aria-hidden="true" data-id="element-527" data-mp="2kmh9pucxjzgl" />
                {selectedAngle.visual}
              </span>
            </div>
            <h3 className="mt-5 font-display text-2xl font-medium tracking-tight" data-id="element-528" data-mp="f0t9rd85wmy3">{selectedAngle.headline}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-529" data-mp="a1ztxe5ekjur">{selectedAngle.body}</p>
            <span className="mt-4 inline-flex rounded-full bg-ink px-4 py-2 text-xs font-semibold text-cream" data-id="element-530" data-mp="nxakwggj0ktu">{selectedAngle.cta}</span>
          </div>

          <dl className="mt-5 grid grid-cols-2 gap-4 border-t border-[#BB5E40]/20 pt-5 text-sm sm:grid-cols-3" data-id="element-531" data-mp="3seobaijhc7t9">
            <Summary label="Inventory" value={`${selectedInventory.units.toLocaleString('en-US')} units`} data-id="element-532" data-mp="3nftf8ewi4mr7" />
            <Summary label="Suggested budget" value="$4,200" data-id="element-533" data-mp="523pjdssmqeo" />
            <Summary label="Projected recovery" value={selectedInventory.recovery} data-id="element-534" data-mp="9aq95g3ga9z" />
          </dl>

          <div className="mt-5 flex flex-wrap gap-3" data-id="element-535" data-mp="38ouc3jefqqf0">
            <button type="button" className="rounded-full bg-[#BB5E40] px-5 py-2.5 text-sm font-semibold text-cream transition-colors hover:bg-[#A34E33]" data-id="element-536" data-mp="38nj7xih2vgnd">
              Send for approval
            </button>
            <button type="button" className="rounded-full border border-ink/15 px-5 py-2.5 text-sm font-semibold text-ink/70 transition-colors hover:bg-paper" data-id="element-537" data-mp="2ui945vq5okqo">
              Regenerate
            </button>
          </div>
        </div>
      </div>
    </section>;
}
function Field({
  label,
  children
}: {
  label: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-538" data-mp="3dbwl7dbsme6p">
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-539" data-mp="3db4sca9kyuk4">{label}</p>
      {children}
    </div>;
}
function Summary({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return <div data-id="element-540" data-mp="33ei3zbi1pldc">
      <dt className="text-[11px] font-semibold uppercase tracking-wider text-ink/45" data-id="element-541" data-mp="33erur1awzwk3">{label}</dt>
      <dd className="mt-1 font-semibold text-ink" data-id="element-542" data-mp="38dbm5h8a20ju">{value}</dd>
    </div>;
}